import React, { useState, useEffect } from "react";
import "./leftSidePanel.css";

const LeftSidePanel = () => {
  return (
    <div
      className="w-3/5 hidden left-div bg-cover bg-center relative hidden  lg:flex h-screen"
      style={{ backgroundImage: `url("/admin-bg.png")` }}
    >
      <div className="absolute inset-0 bg-opacity-100 flex flex-col justify-center items-center text-center p-10 text-white">
        <img
          src="/Caprock-Logo.svg"
          alt="Logo"
          className="absolute top-8 left-8"
        />
        <div className="absolute text-prop text-fixed bottom-10 left-0 mb-8 ml-8 text-white text-xl">
          <h1
            class="text-4xl font-light text-white"
          >
            Hello!
            <br />
            Welcome to the
            <br />
            <span
              class="text-white font-medium"
            >
              Admin Dashboard
            </span>
          </h1>
        </div>
      </div>
    </div>
  );
};
export default LeftSidePanel;
